import React, { useEffect, useState } from "react";
import { AlertInfo } from "../../common/Alert";
import BootstrapTable from "react-bootstrap-table-next";
import { BsTrash } from "react-icons/bs";
import { MdOutlineModeEdit, MdUnarchive } from "react-icons/md";
import TableSkeleton from "../../common/TableSkeleton";
import { NavLink } from "react-router-dom";
import { useGetSecretaireByCabinetQuery } from "../../../utils/api/user/user.api";
import { useAppSelector } from "../../../redux/hook";
import { CustomPagination } from "../../common/CustomPagination";
import { IUser } from "../../../utils/api/user/user.type";
import { getName } from "../../../utils/Utils";
import { UseActiveSecretaire, UseArchiveSecretaire, UseDeleteSecretaire } from "./form/UseAddOrEditSecretaireForm";
import { BiArchiveIn } from "react-icons/bi";

const BtnArchive = ({ item }: { item: IUser }) => {
  const onArchive = UseArchiveSecretaire(item);

  return (
    <button
      className="btn with-tooltip btn-action-icon-delete"
      data-tooltip-content={item?.is_archive ? "Désarchiver" : "Archiver"}
      style={{ color: "#E53E3E" }}
      onClick={onArchive}
    >
      {/* <BsTrash /> */}
      {item?.is_archive ? <MdUnarchive /> : <BiArchiveIn />}
    </button>
  );
};

const BtnActive = ({ active, item }: { active: boolean; item: IUser }) => {
  const onActive = UseActiveSecretaire(item);

  return (
    <>
      {active === true ? (
        <span
          className="btn statut-cabinet-actif with-tooltip"
          onClick={onActive}
          data-tooltip-content="Désactiver"
        >
          Actif
        </span>
      ) : (
        <span
          className="btn statut-cabinet-inactif with-tooltip"
          onClick={onActive}
          data-tooltip-content="Activer"
        >
          Inactif
        </span>
      )}
    </>
  );
};

const BtnDelete = ({ slug, redirect }: { slug: string; redirect?: string }) => {
  const onDelete = UseDeleteSecretaire(slug, redirect);

  return (
    <button
      className="btn with-tooltip btn-action-icon-delete"
      data-tooltip-content={"Supprimer"}
      style={{ color: "#E53E3E" }}
      onClick={onDelete}
    >
      <BsTrash />
    </button>
  );
};

function SecretaireMedicalTable({q}:{q:string}) {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const { user } = useAppSelector((s) => s?.user);
  const { data = { results: [], count: 0 }, isLoading,refetch } =
    useGetSecretaireByCabinetQuery({
      page,
      limit,
      slug: user?.slug,
      q
    });

    useEffect(() => {
      if (!isLoading) refetch();
    }, []);

  const actionFormatter = (cell: string, row: IUser) => {
    return (
      <>
        <div className="d-flex justify-content-center gap-3">
          <div className="container-btn-action-icon-modal">
            <NavLink
              to={`/cabinet/secretaires/modifier-secretaire/${cell}`}
              className="btn btn-action-icon-edit with-tooltip"
              data-tooltip-content="Modifier"
              state={row}
            >
              <MdOutlineModeEdit />
            </NavLink>
          </div>
          <div className="container-btn-action-icon-modal">
            <BtnArchive item={row} />
          </div>
          <div className="container-btn-action-icon-modal">
            {/* <button
              className="btn with-tooltip btn-action-icon-delete"
              data-tooltip-content="Supprimer"
              style={{ color: "#E53E3E" }}
            >
              <BsTrash />
            </button> */}
            <BtnDelete slug={cell} />
          </div>
        </div>
      </>
    );
  };

  const statutFormatter = (cell: boolean, row: IUser) => {
    return (
      <>
        {/* <span className="statut-cabinet-actif">Actif</span> */}
        <BtnActive active={cell} item={row} />
      </>
    );
  };

  const columns = [
    {
      dataField: "prenom",
      text: `Prénom et Nom`,
      formatter: (cell: string, row: IUser) => getName(row),
    },
    {
      dataField: "email",
      text: "ADRESSE MAIL",
    },
    {
      dataField: "telephone",
      text: "Contact",
    },
    {
      dataField: "praticien",
      text: "ASSIGNÉ à",
      formatter: (cell: string, row: IUser) => getName(row?.praticien),
    },
    {
      dataField: "is_active",
      text: "statut",
      formatter: statutFormatter,
      headerStyle: () => {
        return { width: "100px", whiteSpace: "normal" };
      },
    },
    {
      dataField: "slug",
      text: "Action",
      formatter: actionFormatter,
    },
  ];

  return (
    <>
      {isLoading && <TableSkeleton headers={columns} />}
      {!isLoading && (
        <>
          <BootstrapTable
            keyField="id"
            data={data?.results}
            columns={columns}
            rowClasses="custom-table-row-class"
            condensed
            hover
            wrapperClasses="table-responsive admin-table"
            noDataIndication={() => (
              <AlertInfo message="Aucune donnée trouvée" />
            )}
          />
          <div className="custom-pagination-container">
            <CustomPagination
              nbPages={data?.count}
              page={page}
              onChange={(page, perPage) => {
                setLimit(perPage);
                setPage(page);
              }}
              perPage={limit}
            />
          </div>
        </>
      )}
    </>
  );
}

export default SecretaireMedicalTable;
